import { AiOutlineLink } from 'react-icons/ai';

const ShareButton = ({
  onClick,
}: {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  return (
    <button
      className="text-sm leading-[16px] tracking-[-0.1px] sm:max-w-none w-full px-4 py-2 rounded-md hover:bg-[#F1F1F1] bg-[#F1F1F1] flex items-center justify-center flex-1"
      onClick={onClick}
    >
      <div className="w-full flex justify-center items-center gap-x-1">
        <AiOutlineLink size={20} />
        Chia sẻ
      </div>
    </button>
  );
};
export default ShareButton;
